import React, { useState } from 'react';
import { letterAPI } from '../api/documents';
import '../styles/DocumentForms.css';

function CreateLetter() {
  const [formData, setFormData] = useState({
    to_name: '',
    subject: 'TO WHOM IT MAY CONCERN',
    body: '',
  });
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(null);
  const [error, setError] = useState(null);

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError(null);
    setSuccess(null);

    try {
      const result = await letterAPI.create(formData);
      setSuccess(result);
      setFormData({
        to_name: '',
        subject: 'TO WHOM IT MAY CONCERN',
        body: '',
      });
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  const downloadPDF = () => {
    if (success && success.pdf) {
      // Check if PDF path is already a full URL
      const pdfUrl = success.pdf.startsWith('http')
        ? success.pdf
        : `${process.env.REACT_APP_API_URL || 'http://localhost:8000'}${success.pdf}`;
      window.open(pdfUrl, '_blank');
    }
  };

  return (
    <div className="document-form-page">
      <div className="form-container">
        <h1 className="form-title">Create Official Letter</h1>
        <p className="form-subtitle">Generate a professional letter on Robolog letterhead</p>

        {error && (
          <div className="alert alert-error">
            <strong>Error:</strong> {error}
          </div>
        )}

        {success && (
          <div className="alert alert-success">
            <strong>Success!</strong> Letter created with reference: <strong>{success.ref_no}</strong>
            {success.pdf && (
              <button onClick={downloadPDF} className="btn-download">
                📥 Download PDF
              </button>
            )}
          </div>
        )}

        <form onSubmit={handleSubmit} className="document-form">
          <div className="form-group">
            <label htmlFor="to_name">Recipient Name *</label>
            <input
              type="text"
              id="to_name"
              name="to_name"
              value={formData.to_name}
              onChange={handleChange}
              required
              placeholder="Enter recipient's name"
            />
          </div>

          <div className="form-group">
            <label htmlFor="subject">Subject *</label>
            <input
              type="text"
              id="subject"
              name="subject"
              value={formData.subject}
              onChange={handleChange}
              required
              placeholder="Letter subject"
            />
          </div>

          <div className="form-group">
            <label htmlFor="body">Letter Body *</label>
            <textarea
              id="body"
              name="body"
              value={formData.body}
              onChange={handleChange}
              required
              rows="12"
              placeholder="Enter the letter content here..."
            />
            <small className="form-hint">
              Tip: Write a professional letter body. The letterhead and signature will be added automatically.
            </small>
          </div>

          <button type="submit" className="btn-submit" disabled={loading}>
            {loading ? '⏳ Generating...' : '📝 Generate Letter'}
          </button>
        </form>
      </div>
    </div>
  );
}

export default CreateLetter;
